import { useState } from 'react';
import Head from './Head';
import { useFormik } from 'formik';
import Step1 from './Step1';
import Step2 from './Step2';
import Step3 from './Step3';
import CompleteSignup from '../CompleteSignup';
import { signUpRealestate } from '@services/Api';
import { validateNationalID } from '@helper/functions';
import ToastError from '../../toast/ToastError';
import ToastSuccess from '../../toast/ToastSuccess';

export default function SignupRealestate() {
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);

  const formikSignUpRealestate = useFormik({
    initialValues: {
      firstName: '',
      lastName: '',
      nationalID: '',
      statusBusinessLicense: '',
      nameAgency: '',
      subdomain: '',
      subdomainOriginal: '',
      telAgency: '',
      tradeID: null,
      logo: null,
      province: '',
      city: '',
      address: '',
      coordinate: '',
    },
    validate: (values) => {
      const errors = {};
      const phoneRegExp = /^0[1-9]\d{1,2}-?\d{7,8}$/;
      const englishLetterRegExp = /[a-zA-Z]/g; // پیدا کردن تمام حروف انگلیسی

      if (!values.firstName.trim()) {
        errors.firstName = 'نام را وارد کنید';
      }
      if (!values.lastName.trim()) {
        errors.lastName = 'نام خانوادگی را وارد کنید';
      }
      if (!values.nationalID) {
        errors.nationalID = 'کد ملی را وارد کنید';
      } else if (!validateNationalID(values.nationalID)) {
        errors.nationalID = 'لطفا یک کد ملی معتبر وارد کنید';
      }
      if (!values.statusBusinessLicense && step > 1) {
        errors.statusBusinessLicense = 'وضعیت پروانه کسب را انتخاب کنید';
      }
      if (!values.nameAgency.trim() && step > 1) {
        errors.nameAgency = 'نام آژانس را وارد کنید';
      }
      if (!values.subdomain.trim() && step > 1) {
        errors.subdomain = 'نام را وارد کنید';
      } else if (step > 1) {
        const matches = values.subdomain.match(englishLetterRegExp) || []; // پیدا کردن همه حروف انگلیسی
        if (matches.length < 3) {
          errors.subdomain = 'ساب‌دامین باید حداقل ۳ حرف انگلیسی داشته باشد';
        }
      }
      if (values.subdomainOriginal.trim().length < 3 && step > 1) {
        errors.subdomainOriginal = 'نام را وارد کنید';
      }

      if (!values.telAgency && step > 1) {
        errors.telAgency = 'تلفن ثابت آژانس را وارد کنید';
      } else if (!phoneRegExp.test(values.telAgency) && step > 1) {
        errors.telAgency = 'لطفا یک شماره تلفن معتبر وارد کنید';
      }
      // if (!values.tradeID && step > 1) {
      //   errors.tradeID = "شناسه صنفی را وارد کنید";
      // } else if (values.tradeID.length != 10 && step > 1) {
      //   errors.tradeID = "لطفا یک شناسه صنفی معتبر وارد کنید";
      // }
      // if (!values.logo && step > 1) {
      //   errors.logo = "لوگو را آپلود کنید";
      // }
      if (!values.province && step > 2) {
        errors.province = 'استان را وارد کنید';
      }
      if (!values.city && step > 2) {
        errors.city = 'شهر را وارد کنید';
      }
      if (!values.address.trim() && step > 2) {
        errors.address = 'آدرس را وارد کنید';
      }
      if (!values.coordinate && step > 2) {
        errors.coordinate = 'لوکیشن را انتخاب کنید';
      }

      // if (values.subdomain && step > 1) {
      //   const subdomain = values.subdomain.toLowerCase(); // حروف بزرگ کوچیک بشه
      //   if (subdomain.length < 3 || subdomain.length > 63) {
      //     errors.subdomain = 'نام ساب دامین باید بین ۳ تا ۶۳ کاراکتر باشد';
      //   } else if (!/^[a-z]/.test(subdomain)) {
      //     errors.subdomain = 'ساب دامین باید با یک حرف شروع شود';
      //   } else if (subdomain.startsWith('-') || subdomain.endsWith('-')) {
      //     errors.subdomain = 'ساب دامین نباید با خط فاصله شروع یا تمام شود';
      //   } else if (!subdomainRegExp.test(subdomain)) {
      //     errors.subdomain = 'فقط حروف انگلیسی کوچک، عدد و خط فاصله مجاز است';
      //   }
      // } else if (!values.subdomain && step > 1) {
      //   errors.subdomain = 'نام ساب دامین را وارد کنید';
      // }

      return errors;
    },
    onSubmit: async (values) => {
      if (step === 1) {
        formikSignUpRealestate.setFieldTouched('firstName', true);
        formikSignUpRealestate.setFieldTouched('lastName', true);
        formikSignUpRealestate.setFieldTouched('nationalID', true);
        formikSignUpRealestate.setFieldTouched('statusBusinessLicense', false);
        formikSignUpRealestate.setFieldTouched('nameAgency', false);
        formikSignUpRealestate.setFieldTouched('telAgency', false);
        formikSignUpRealestate.setFieldTouched('tradeID', false);
        formikSignUpRealestate.setFieldTouched('subdomain', false);
        formikSignUpRealestate.setFieldTouched('province', false);
        formikSignUpRealestate.setFieldTouched('city', false);
        formikSignUpRealestate.setFieldTouched('address', false);
        formikSignUpRealestate.setFieldTouched('coordinate', false);
      } else if (step === 2) {
        formikSignUpRealestate.setFieldTouched('statusBusinessLicense', true);
        formikSignUpRealestate.setFieldTouched('nameAgency', true);
        formikSignUpRealestate.setFieldTouched('telAgency', true);
        formikSignUpRealestate.setFieldTouched('tradeID', true);
        formikSignUpRealestate.setFieldTouched('subdomain', true);
        formikSignUpRealestate.setFieldTouched('province', false);
        formikSignUpRealestate.setFieldTouched('city', false);
        formikSignUpRealestate.setFieldTouched('address', false);
        formikSignUpRealestate.setFieldTouched('coordinate', false);
      } else if (step === 3) {
        formikSignUpRealestate.setFieldTouched('address', true);
        formikSignUpRealestate.setFieldTouched('province', true);
        formikSignUpRealestate.setFieldTouched('city', true);
      }
      setStep((prev) => (prev < 3 ? prev + 1 : prev));
      const formDataGenerator = () => {
        const formData = new FormData();

        formData.append(
          'fullName',
          formikSignUpRealestate.values.firstName.trim() + '_' + formikSignUpRealestate.values.lastName.trim(),
        );
        formData.append('nationalId', formikSignUpRealestate.values.nationalID.trim());
        formData.append('name', formikSignUpRealestate.values.nameAgency.trim());
        formData.append('businessLicense', formikSignUpRealestate.values.statusBusinessLicense);
        formData.append('phoneNumber', formikSignUpRealestate.values.telAgency);
        formData.append('subdomain', formikSignUpRealestate.values.subdomainOriginal);
        formData.append(
          'coordinate',
          '[' +
            formikSignUpRealestate.values.coordinate[0].toString() +
            ',' +
            formikSignUpRealestate.values.coordinate[1].toString() +
            ']',
        );
        // formData.append('coordinate', formikSignUpRealestate.values.coordinate.lng.toString());
        formData.append('address', formikSignUpRealestate.values.address.trim());
        formData.append('city', formikSignUpRealestate.values.city);
        if (formikSignUpRealestate.values.tradeID) {
          formData.append('tradeId', formikSignUpRealestate.values.tradeID);
        }
        if (formikSignUpRealestate.values.logo instanceof File) {
          formData.append('profile', formikSignUpRealestate.values.logo, formikSignUpRealestate.values.logo.name);
        }
        return formData;
      };

      if (step === 3) {
        try {
          setLoading(true);

          const resRealestate = await signUpRealestate(formDataGenerator());
          if (resRealestate.status === 'success') {
            ToastSuccess({ content: 'ثبت نام املاک با موفقیت انجام شد' });
            setStep(4);
          } else {
            ToastError({
              content: 'مشکلی در ثبت نام املاک پیش آمده، مجددا تلاش کنید',
            });
          }
        } catch (e) {
          ToastError({ content: 'مشکلی پیش آمده، مجددا تلاش کنید' });
        } finally {
          setLoading(false);
        }
      }
    },
  });

  const handleSubmitAttempt = (e) => {
    e.preventDefault();

    // Manually mark fields as touched based on the step
    if (step === 1) {
      formikSignUpRealestate.setFieldTouched('firstName', true);
      formikSignUpRealestate.setFieldTouched('lastName', true);
      formikSignUpRealestate.setFieldTouched('nationalID', true);
    } else if (step === 2) {
      formikSignUpRealestate.setFieldTouched('statusBusinessLicense', true);
      formikSignUpRealestate.setFieldTouched('nameAgency', true);
      formikSignUpRealestate.setFieldTouched('telAgency', true);
      formikSignUpRealestate.setFieldTouched('tradeID', true);
      formikSignUpRealestate.setFieldTouched('subdomain', true);
    } else if (step === 3) {
      formikSignUpRealestate.setFieldTouched('province', true);
      formikSignUpRealestate.setFieldTouched('city', true);
      formikSignUpRealestate.setFieldTouched('address', true);
    }

    // Trigger validation
    formikSignUpRealestate.validateForm().then((errors) => {
      if (Object.keys(errors).length === 0) {
        formikSignUpRealestate.handleSubmit(e); // Only submit if no errors
      }
    });
  };

  const renderStep = () => {
    switch (step) {
      case 1:
        return (
          <Step1
            formikSignUpRealestate={formikSignUpRealestate}
            handleSubmitAttempt={handleSubmitAttempt}
            setStep={setStep}
          />
        );
      case 2:
        return (
          <Step2
            formikSignUpRealestate={formikSignUpRealestate}
            handleSubmitAttempt={handleSubmitAttempt}
            setStep={setStep}
          />
        );
      case 3:
        return (
          <Step3
            formikSignUpRealestate={formikSignUpRealestate}
            handleSubmitAttempt={handleSubmitAttempt}
            setStep={setStep}
            loading={loading}
          />
        );
      case 4:
        return <CompleteSignup role="مدیر" />;

      default:
        return <Step1 formikSignUpRealestate={formikSignUpRealestate} />;
    }
  };
  return (
    <div className="flex flex-col w-full h-full items-center justify-start gap-4 md:gap-8">
      {/* <h3 className="text-xl md:text-2xl 2xl:text-3xl font-bold whitespace-nowrap">
        برای ثبت نام اطلاعات زیر را تکمیل نمایید .
      </h3> */}
      <Head step={step} />
      {renderStep()}
    </div>
  );
}
